import { Rule } from './rule';

export class MarblesCheatSheet {
  public static readonly allCheatSheets: Rule[] = [
    {
      title: 'components.cheat-sheet.marbles.header-1',
      body: [{ type: 'text', content: 'components.cheat-sheet.marbles.body-1' }],
    },
    {
      title: 'components.cheat-sheet.marbles.header-2',
      body: [
        { type: 'text', content: 'components.cheat-sheet.marbles.body-2a' },
        { type: 'text', content: 'components.cheat-sheet.marbles.body-2b' },
      ],
    },
    {
      title: 'components.cheat-sheet.marbles.header-3',
      body: [
        { type: 'text', content: 'components.cheat-sheet.marbles.body-3a' },
        { type: 'text', content: 'components.cheat-sheet.marbles.body-3b' },
        { type: 'text', content: 'components.cheat-sheet.marbles.body-3c' },
        { type: 'text', content: 'components.cheat-sheet.marbles.body-3d' },
      ],
    },
    {
      title: 'components.cheat-sheet.marbles.header-4',
      body: [
        { type: 'text', content: 'components.cheat-sheet.marbles.body-4a' },
        { type: 'text', content: 'components.cheat-sheet.marbles.body-4b' },
        { type: 'text', content: 'components.cheat-sheet.marbles.body-4c' },
        { type: 'text', content: 'components.cheat-sheet.marbles.body-4d' },
      ],
    },
  ];
}
